import React, { useState, useEffect } from 'react'
import Login from './Login'
import NotFound from './NotFound'
import Ranking from './Ranking'
import { Admin } from './Admin'
import config from '../config'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import Amplify, { Auth } from 'aws-amplify'
import { CognitoAuth } from 'amazon-cognito-auth-js'
import { authConfig } from '../config'
import { isAdmin } from '../api'
import Voting from './Voting'

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
    oauth: {
      redirectSignOut: 'https://rancor.wwest.com/login',
    },
  },
})

const AuthContext = React.createContext()
const auth = new CognitoAuth(authConfig)
auth.userhandler = {
  onSuccess: result => {
    return <Redirect to="/"></Redirect>
  },
  onFailure: error => console.log('error', error),
}

const ImplicitCallback = () => {
  auth.parseCognitoWebResponse(window.location.href)
  return <Redirect to="/"></Redirect>
}

const Routes = props => {
  const [loggedIn, setLoggedIn] = useState(false)
  const [admin, setAdmin] = useState(false)

  useEffect(() => {
    const getCurrentSession = async () => {
      try {
        await Auth.currentSession()
        setLoggedIn(true)
      } catch {}
      setAdmin(await isAdmin())
    }
    getCurrentSession()
  })

  return (
    <AuthContext.Provider value={{ loggedIn, setLoggedIn, errorMessage: 'Error Message', auth, admin }}>
      <Router>
        <Switch>
          <Route exact path="/" render={() => (loggedIn ? <Voting /> : <Login sso />)} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/ranking" render={() => (admin ? <Ranking /> : <Redirect to="/" />)} />
          <Route exact path="/admin" render={() => (admin ? <Admin /> : <Redirect to="/" />)} />
          <Route exact path="/implicit/callback" component={ImplicitCallback} />
          <Route component={NotFound} />
        </Switch>
      </Router>
    </AuthContext.Provider>
  )
}

export { AuthContext, Routes }
